import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { validateInputText } from "../../../utilities/ValidateUtil";
export default function P410Search3({ dataInfoB, action, onChangeAction, submitForm, submitted }) {
    const [data, setData] = useState({
        criteriaNo: "",
        criteriaDesc: "",
        criteriaWeight: "",
    });

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    useEffect(() => {
        console.log("🚀 ~ file: P410Search3.js ~ line 36 ~ P410Search3 ~ dataInfoB", dataInfoB)
        //topicNo

        if (action && action.action === "แก้ไข") {
            if(dataInfoB === undefined)return;
            setData({
                criteriaNo: dataInfoB.criteriaNo,
                criteriaDesc: dataInfoB.criteriaDesc,
                criteriaWeight: dataInfoB.criteriaWeight,
            });
        } else {
            setData({
                criteriaNo: 0,
                criteriaDesc: "",
                criteriaWeight: "",
            });
        }

        // if (action && action.action === "แก้ไข") {
        //     setData({
        //         versionNo: dataInfoA.versionNo ? dataInfoA.versionNo : 0,
        //         beginDate: dataInfoA && dataInfoA.beginDate && dataInfoA.beginDate !== "" ? new Date(dataInfoA.beginDate) : new Date(),
        //         endDate: dataInfoA && dataInfoA.endDate && dataInfoA.endDate !== "" ? new Date(dataInfoA.endDate) : new Date(),
        //         remark: dataInfoA.remark,
        //     });
        // } else {
        //     setData({
        //         versionNo: 0,
        //         beginDate: new Date(),
        //         endDate: new Date(),
        //         remark: "",
        //     });
        // }

    }, [dataInfoB]);

    return (
        <>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-1"></div>
                <div className="p-field p-col-12 p-md-3">
                    <label>ข้อ</label>
                    <InputText type="text" placeholder="แบบที่" value={data.criteriaNo} disabled />
                </div>
                <div className="p-field p-col-12 p-md-3">
                    <label>น้ำหนัก</label>
                    <InputNumber
                        placeholder="น้ำหนัก"
                        inputId="criteriaWeight"
                        className="p-invalid"
                        value={data.criteriaWeight}
                        onValueChange={(e) => onInputTextChange(e, "criteriaWeight")}
                        mode="decimal"
                        useGrouping={false}
                        max={99999}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                    />
                    {submitted && !data.criteriaWeight && validateInputText("criteriaWeight", "น้ำหนัก")}
                </div>
            </div>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-1"></div>
                <div className="p-field p-col-12 p-md-6">
                    <label>หัวข้อพิจารณา</label>
                    <InputText
                        type="text" placeholder="หัวข้อพิจารณา"
                        value={data.criteriaDesc} maxLength="200"
                        className="p-invalid"
                        onChange={(e) => onInputTextChange(e, "criteriaDesc")}
                    />
                    {submitted && !data.criteriaDesc && validateInputText("criteriaDesc", "หัวข้อพิจารณา")}
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <div style={{ display: "flex", marginBottom: "10px" }}>
                        <Button className="p-button p-button-success btn-srh-responsive"
                            icon="pi pi-save"
                            // label={action.action}
                            label={"บันทึก"}
                            style={{ width: 130 }} onClick={() => submitForm(data)} />

                        <Button
                            className="p-button-secondary p-button btn-srh-responsive"
                            icon ="pi pi-arrow-left"
                            label="กลับหน้าจอหลัก"
                            style={{ width: 130, marginLeft: "5px" }}
                            // onClick={() => {setAction({tab:1}) }}
                            onClick={() => onChangeAction(2,'แก้ไข')}
                        />
                        {action && action.action === "แก้ไข" ? <Button className="p-button-danger p-button btn-srh-responsive" icon="pi pi-trash" label="ลบรายการ" style={{ width: 130, marginLeft: "5px" }} onClick={() => submitForm(data, "ลบรายการ")} /> : ""}
                    </div>
                </div>
            </div>
        </>
    );
}
